import { Component, OnInit } from '@angular/core';
import { PeerToPeerConfirmationComponent } from '../peer-to-peer-confirmation/peer-to-peer-confirmation.component';
import { SharedPeerToPeerModule } from '@pages/send-money/components/peer-to-peer/shared-peer-to-peer.module';
import { SharedPeerToPeerComponent } from '@pages/send-money/components/peer-to-peer/shared-peer-to-peer.component';
@Component({
    standalone: true,
    selector: 'app-peer-to-peer',
    templateUrl: './peer-to-peer.component.html',
    styleUrls: ['./peer-to-peer.component.scss'],
    imports: [SharedPeerToPeerModule],
})
export class PeerToPeerComponent extends SharedPeerToPeerComponent implements OnInit {
    override ngOnInit(): void {
        super.ngOnInit();
        this.redirectToComponent = PeerToPeerConfirmationComponent;
        this.form.controls.senderCurrency.valueChanges.subscribe((currency) => {
            this.form.controls.receiverCurrency.setValue(currency);
        });
    }

    override processAccountInfo() {
        Object.keys(this.senderAccounts[0].balances).map((currency) => {
            this.senderWalletInfo.set(currency, {
                balance: this.senderAccounts[0].balances[currency],
                walletId: this.senderAccounts[0].id,
            });
        });

        Object.keys(this.recipientAccounts[0].balances).map((currency) => {
            this.ReceiverWalletInfo.set(currency, {
                balance: this.recipientAccounts[0].balances[currency],
                walletId: this.recipientAccounts[0].id,
            });
        });
    }
}
